if (!customElements.get('ai-chat-search-bar')) {
  class AIChatSearchBar extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.ai-chat-search-bar__form');
      this.input = this.querySelector('.ai-chat-search-bar__input');
      this.optionButtons = this.querySelectorAll('.ai-chat-search-bar__option-btn');

      if (this.form) this.onFormSubmit();
      if (this.optionButtons.length) this.onOptionClick();
    }

    sendToQuickchat(text) {
      if (!text || typeof window._quickchat !== 'function') return;

      window._quickchat('message', text);
    }

    onFormSubmit() {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const query = formData.get('query')?.trim();
        if (!query) return;

        this.sendToQuickchat(query);
        e.target.reset();
      });
    }

    onOptionClick() {
      this.optionButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          const value = btn.dataset.value?.trim();
          if (!value) return;

          this.sendToQuickchat(value);
        });
      });
    }
  }

  customElements.define('ai-chat-search-bar', AIChatSearchBar);
}
